/**
 * API endpoint path constants.
 * Paths are defined here; base URL comes from REACT_APP_API_URL (virtual-core) or PLATFORM domain (platform).
 */

const ENDPOINTS = {
  TICKETS_LIST: '/web/tickets',
  /** @deprecated use TICKETS_LIST */
  TICKETS_LISTS: '/web/tickets',
  TICKETS_CREATE: '/web/tickets',
  CHECK_WINS: '/web/check-wins',
  SCHEDULES_LISTS: '/web/schedules',
  SERVER_TIME: '/web/server-time',
  REQUEST_CREDIT: '/web/request-credit',
  REQUEST_REBUY: '/web/request-rebuy',
  EVENTS_NEXT_LISTS: '/web/events/next/:num_events',
  /** GET /web/schedules/:scheduleId/live - enriched ongoing event (replaces /web/events/ongoing) */
  SCHEDULE_LIVE: '/web/schedules',
  /** GET /web/schedules/:schedule_id/events/upcoming - upcoming OPEN events only (ongoing from GET /live) */
  SCHEDULE_EVENTS_UPCOMING: '/web/schedules/:schedule_id/events/upcoming',
  /** GET /web/schedules/:schedule_id/events/:event_id/results - event results with VOD for mini TV */
  SCHEDULE_EVENT_RESULTS: '/web/schedules/:schedule_id/events/:event_id/results',
  /** Alias for schedule-scoped event results (same as SCHEDULE_EVENT_RESULTS). */
  SCHEDULE_EVENT_RESULTS_WEB: '/web/schedules/:schedule_id/events/:event_id/results',
  EVENT_RESULTS_LISTS: '/web/event-results/:event_id',
  SCHEDULE_WEEKS: '/web/schedules/:schedule_id/weeks',
  SCHEDULE_WEEK_EVENTS: '/web/schedules/:schedule_id/weeks/:weekId/events',
  SCHEDULE_FOOTBALL3D_WEEKS_AND_EVENTS: '/web/schedules/:schedule_id/football3d-weeks-and-events',
  SCHEDULE_STANDINGS: '/schedules/:schedule_id/standings',
  SCHEDULE_RESULTS: '/web/schedules/:schedule_id/results',
  MARKET_TYPES_LISTS: '/web/market-types',
  SCHEDULE_RTP_PREFERENCES: '/schedules/:schedule_id/rtp-preferences',
  LATEST_RESULTS_LISTS: '/web/latest-results',
  SESSIONS_READ: '/web/sessions/:id',
  SESSIONS_CREATE: '/web/sessions/register',
  SESSIONS_UPDATE: '/web/sessions/:id',
  KEEPALIVE_UPDATE: '/web/keepalive',
  GUEST_CONFIG: '/web/config',
  /**
   * PLATFORM
   */
  PLATFORM: {
    SESSIONS_START: '/v1/sessions/start',
    SESSIONS_CSRF: '/v1/sessions/csrf',
    SESSIONS_TOKEN: '/v1/sessions/token',
    SESSIONS_CLOSE: '/v1/sessions/close',
    SESSIONS_PREPAID_SHOW: '/v1/sessions/prepaid',
    SESSIONS_PREPAID_CREATE: '/v1/sessions/prepaid',
    SESSIONS_PREPAID_DELETE: '/v1/sessions/prepaid/delete',
    WALLETS_PAY: '/v1/wallets/pay',
    WALLETS_TOPUPS: '/v1/wallets/topups',
    SESSION_VALIDATE: '/v1/virtual-sports/session/validate',
  },
} as const;

export default ENDPOINTS;
